import { Link } from "react-router-dom";
import Seo, { localBusinessLd, breadcrumbLd } from "@/lib/seo";

export default function RamaDecoPage() {
  return (
    <div className="pt-[100px] md:pt-[140px] pb-24">
      <Seo
        title="RAMA DÉCO — Entreprise de travaux intérieurs et second œuvre à Villepinte (93)"
        description="RAMA DÉCO, entreprise de rénovation intérieure basée à Villepinte : plusieurs corps d'état, un seul interlocuteur. SIREN 824 763 015, interventions en Île-de-France."
        path="/rama-deco"
        jsonLd={[localBusinessLd(), breadcrumbLd([{ to: "/", label: "Accueil" }, { to: "/rama-deco", label: "RAMA DÉCO" }])]}
      />
      <div className="wrap">
        <div className="font-mono-caption text-bordeaux-700 mb-4">RAMA DÉCO · Construction & Rénovation</div>
        <h1 className="font-display text-4xl md:text-6xl tracking-tight text-anthracite max-w-4xl leading-[1.02]">
          Le bâtiment intérieur devrait être plus <span className="italic text-bordeaux-700">simple.</span>
        </h1>

        <div className="mt-14 grid md:grid-cols-12 gap-10">
          <div className="md:col-span-7 space-y-6 text-ink-soft text-lg leading-relaxed">
            <p>Vous n'avez pas à gérer un peintre, un plaquiste, un plombier, un électricien, un carreleur et un menuisier séparément. C'est le rôle de RAMA DÉCO.</p>
            <p>Nous sommes spécialistes des <b>travaux intérieurs, de la rénovation et du second œuvre</b>. Nous intervenons dans des espaces existants (appartements, maisons, bureaux, commerces) comme dans des bâtiments neufs livrés au stade des finitions intérieures.</p>
            <p className="font-display text-2xl text-anthracite border-l-2 border-bordeaux-700 pl-6 italic">Plusieurs métiers intérieurs. Un seul interlocuteur.</p>
            <p>Notre périmètre : peinture, placo, cloisons non porteuses, sols, salle de bains, plomberie et électricité intérieures, menuiserie intérieure, isolation, dépose non structurelle et finitions.</p>
            <p className="text-sm bg-greige/40 border-l-2 border-anthracite p-4 rounded-r">RAMA DÉCO n'intervient pas sur le gros œuvre ni sur la structure du bâtiment (fondations, murs porteurs, charpente, dalle porteuse). Pour ces travaux, une entreprise spécialisée en gros œuvre est nécessaire.</p>
          </div>
          <div className="md:col-span-5">
            <img src="https://images.unsplash.com/photo-1741764014072-68953e93cd48?w=1200&q=85" alt="Chantier intérieur" className="w-full aspect-[4/5] object-cover rounded-rama-md" />
          </div>
        </div>

        <div className="mt-24 grid sm:grid-cols-3 gap-px bg-black/10 border border-black/10 rounded-rama-md overflow-hidden">
          {[
            { t: "Second œuvre & finitions", d: "Peinture, placo, sols, salle de bains, électricité et plomberie intérieures, menuiserie." },
            { t: "Interlocuteur unique", d: "Un conducteur de travaux dédié suit votre chantier de bout en bout." },
            { t: "Île-de-France", d: "Villepinte, Paris et toute la région. Interventions coordonnées." },
          ].map(x => (
            <div key={x.t} className="bg-ivory p-8">
              <div className="font-display text-2xl text-anthracite mb-3">{x.t}</div>
              <div className="text-ink-soft text-sm leading-relaxed">{x.d}</div>
            </div>
          ))}
        </div>

        <div className="mt-24 flex flex-col md:flex-row gap-4">
          <Link to="/estimation" className="btn-primary">Décrire un projet</Link>
          <Link to="/contact" className="btn-ghost">Nous contacter</Link>
        </div>
      </div>
    </div>
  );
}
